import { IntlShape } from "react-intl";
import { SearchFilterOption } from "../SearchDialog/SearchDialog.types";
import { DocumentType } from "../SearchResultRow/SearchResultRow.types";

export const getSearchFilterOptions = (intl: IntlShape): SearchFilterOption[] => [
  {
    value: DocumentType.All,
    label: intl.formatMessage({
      defaultMessage: "All",
    }),
  },
  {
    value: DocumentType.Budgets,
    label: intl.formatMessage({
      defaultMessage: "Budgets",
    }),
  },
  {
    value: DocumentType.Proposals,
    label: intl.formatMessage({
      defaultMessage: "Proposals",
    }),
    supportInBudgetSearch: true,
  },
  {
    value: DocumentType.Worksheets,
    label: intl.formatMessage({
      defaultMessage: "Worksheets",
    }),
    supportInBudgetSearch: true,
  },
  {
    value: DocumentType.Stories,
    label: intl.formatMessage({
      defaultMessage: "Stories or Publications",
    }),
  },
  {
    value: DocumentType.Reports,
    label: intl.formatMessage({
      defaultMessage: "Reports",
    }),
  },
  {
    value: DocumentType.Workforce,
    label: intl.formatMessage({
      defaultMessage: "Workforce",
    }),
    checkPermissions: ({ isWorkforceAuthorized }) => {
      return isWorkforceAuthorized;
    },
  },
];

export const getUserBudgetIdStorageKey = (entityId: string, userUuid: string) => {
  return `${entityId}_${userUuid}_user_budget_id`;
};
